var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolveLayoutVariant,{tag:"component"},[_c('router-view',{staticClass:"px-md-16 px-sm-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }